import { InteractionType } from '@lendi/core-constants';

export {
  BAA_TRACKING_TEXT,
  BAA_TRACKING_POSITION_PAGE,
  BAA_TRACKING_BUTTON_CLICKED,
  BAA_TRACKING_LINK_CLICKED,
  BAA_TRACKING_APPT_TYPE,
  BAA_TRACKING_APPT_FORM_ELEMENT_ANSWER,
  BAA_TRACKING_APPT_TYPES,
  BAA_TRACKING_MODAL_TYPES,
  BAA_TRACKING_PAGE_VIEWED,
} from './eventTrackings';

export * from './statusCodes';

export { AUS_TIMEZONES } from './timezones';
export { TEAM_ROLES_FOR_F2F_APPT, THIRD_PARTY_TEAM_ROLES } from './roles';

export const interactionTypeLabelMapping = {
  [InteractionType.Phone]: 'phone',
  [InteractionType.FaceToFace]: 'in-person',
  [InteractionType.Video]: 'video',
  [InteractionType.Store]: 'store',
};

export const URL_PARAM_CUSTOMER_ID = 'customerId';

export const THIRD_PARTY_BOOKING = 'third-party-booking';
export * from './cancellationReason';
export * from './calendarType';
export * from './appointmentJourney';
export * from './interactionTypes';
